



  import React, { Component } from 'react';
  import { Link } from 'react-router-dom';
  // import Ico from './iconBox';
  
  // import HomeBlog from '../assets/images/blog_1.jpg';
  // import person1 from '../assets/images/person_1.jpg';
  // import person2 from '../assets/images/person_2.jpg';
  // import person3 from '../assets/images/person_3.jpg';
  // import person4 from '../assets/images/person_4.jpg';

  import hotelBanner from '../img/about-us-header.png';
  
  class Home extends Component {
      state = {
  
      }
      componentDidMount(){
          window.scrollTo(0, 0)
  
      }
      render() {
          return (
              <div>
              
   <section
  className="page-header py-5 text-center text-white"
  style={{
    position: 'relative',
    backgroundImage: `url(${hotelBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '400px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  }}
>
  {/* Overlay for dark blur */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(6px)',
      zIndex: 1
    }}
  ></div>

  {/* Header content */}
  <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
    <h1 className="display-4 fw-bold">Contact Us</h1>
    <p className="lead">Find Verified & Trusted Hotel Stays with YOVHO</p>

    {/* Breadcrumb */}
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb justify-content-center mt-3">
        <li className="breadcrumb-item">
          <a href="/" className="text-white text-decoration-none">Home</a>
        </li>
        <li className="breadcrumb-item active" aria-current="page" style={{ color: "white" }}>
          Contact Us
        </li>
      </ol>
    </nav>
  </div>
</section>

   
   
   
   
   
  
  
  <br/>
  
  
  
  <div className="container">
      <div className="row">
          <div className="col-12">
    
    
  
  
  
  
  
  
  
  
  
  <h1>Welcome to YOVHO’s Contact Page</h1>
  <p>Greetings from YOVHO! We understand that travel and hospitality sometimes come with questions or unexpected hiccups. That’s why our customer support team is here to help—24/7. Whether you’re a guest, partner, or curious traveler, this page gives you all the information you need to contact us easily.</p>

  <h2>Get in Touch with Us – The Smart Way</h2>
  <p>Looking for a YOVHO customer service number? We’ve streamlined the way you reach us. Instead of relying on outdated hotlines, we offer faster, smarter communication through our integrated support platform. No long hold times—just instant, reliable help.</p>

  <h2>💬 Instant Support at Your Fingertips</h2>
  <p>Our experienced YOVHO support team is available 24/7 via our real-time messaging system. You can connect with us directly through our website or mobile app for help with:</p>
  <ul>
    <li>Reservations</li>
    <li>Cancellations or changes</li>
    <li>Payments & refunds</li>
    <li>Technical issues</li>
    <li>General inquiries</li>
  </ul>
  <p>We’ve built our system so that getting assistance is as easy and seamless as possible.</p>

  <h2>How to Reach Us</h2>
  <ul>
    <li><strong>Visit the YOVHO Website or App:</strong> Log into your YOVHO account to access all support options.</li>
    <li><strong>Navigate to the Help Center:</strong> Our Help Center features detailed FAQs and quick guides to resolve most issues instantly.</li>
    <li><strong>Chat with Us Directly:</strong> Didn’t find what you need? Use the live messaging feature to speak with our support team in real time.</li>
  </ul>

  <h2>Why We Use Messaging (Instead of Phone Calls)</h2>
  <ul>
    <li>No Wait Times – Get support instantly, without being placed on hold.</li>
    <li>24/7 Access – No matter the time zone, we’re here.</li>
    <li>Track Your Support History – Review past conversations anytime.</li>
  </ul>

  <h2>Escalated Support When Needed</h2>
  <p>In special cases, if your concern requires advanced attention, our team will escalate your issue internally—without you needing to speak to different departments. We handle the complexity so you don’t have to.</p>

  <h2>Your Feedback Matters</h2>
  <p>Every message you send helps us improve. While we no longer rely on traditional phone lines, we remain committed to delivering exceptional, human-centered support through modern, efficient channels.</p>

  <p>So next time you’re looking for a YOVHO contact number, remember—we’re only a few clicks away.</p>
  <p><strong>Phone:</strong><br/>
  UAE: +971 55 556 2053<br/>
  Pakistan: +92 316 661 1136</p>

  <p><strong>Email:</strong><br/>
  <a href="mailto:customer.care@yovho.com">customer.care@yovho.com</a></p>


  
  
  
  
  
          </div>
      </div>
  </div>
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
          
            </div>
          )
      }
  }
  
  export default Home;